import {
  IconButton,
  InputAdornment,
  Stack,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Loader from "../../../common/Loader";
import { Formik } from "formik";
import { useStyles } from "../AddOrEdituser/styles";
import * as Yup from "yup";
import useAuthStore from "../../../hooks/store/auth";
import { useLocation, useNavigate } from "react-router-dom";
import FormPageLayout from "../../../common/forms/FormPageLayout";
import FormikTextField from "../../../common/forms/FormikTextField";
import SubmitCancelActions from "../../../common/forms/SubmitCancelActions";

const Index = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const initialValues = {
    password: "",
    confirm: "",
  };
  const { updateAction, loading } = useAuthStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const targetUser = location.state?.users || null;
  const hasPasswordTarget = Boolean(targetUser?.email);

  React.useEffect(() => {
    if (!hasPasswordTarget) {
      navigate("/users", { replace: true });
    }
  }, [hasPasswordTarget, navigate]);

  const passwordValidationSchema = Yup.object({
    password: Yup.string().max(255).required("Password is required"),
    confirm: Yup.string()
      .max(255)
      .required("Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  const handlePasswordSubmit = async (values) => {
    const result = await updateAction({
      email: targetUser?.email,
      password: values.password,
      confirm: values.confirm,
      redirectTo: "/users",
      logoutAfterSuccess: false,
    });

    if (result?.type === "auth/update/fulfilled") {
      navigate("/users");
    }
  };

  if (!hasPasswordTarget) {
    return null;
  }

  return (
    <>
      {loading && <Loader />}
      <Formik
        initialValues={initialValues}
        validationSchema={passwordValidationSchema}
        onSubmit={handlePasswordSubmit}
      >
        {(formik) => {
          const { handleChange, handleBlur, handleSubmit, values, errors, touched } =
            formik;
          const textFieldProps = {
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            errorClassName: classes.error,
          };

          return (
            <FormPageLayout
              title="Change Password"
              cardTitle="Password Details"
              formProps={{ onSubmit: handleSubmit }}
              cardClassName={classes.Card}
              headerClassName={classes.heading}
              cardActionsProps={{ sx: { padding: "20px" } }}
              actions={
                <SubmitCancelActions
                  buttonClassName={classes.button}
                  onCancel={() => navigate("/users")}
                  submitLabel="Update Password"
                />
              }
            >
              <Stack spacing={2} sx={{ maxWidth: 600 }}>
                <FormikTextField
                  {...textFieldProps}
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormikTextField
                  {...textFieldProps}
                  fullWidth
                  name="confirm"
                  label="Password (Confirm)"
                  type={showConfirmPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </FormPageLayout>
          );
        }}
      </Formik>
    </>
  );
};

export default Index;
